import { Box, Typography } from "@mui/material";
import React from "react";
import useResponsive from "../../../hooks/useResponsive";

export const DisclaimerBox: React.FC = () => {
  const { isSm, isXs } = useResponsive();
  const isMobile = isSm || isXs;
  return (
    <Box p={isMobile ? 2 : 8} sx={{ background: "#e6e6e6" }}>
      <Typography variant="h6">Disclaimer</Typography>
      <Typography component="div">
        <p>
          <strong>* Condition:</strong>
        </p>
        <ul>
          <li>
            The information used to calculate your pool heating requirement is
            only an estimate and guide only which based on information provided
            by you ("The Customer").
          </li>
          <li>
            This sizing guide is indicative only and non-contractual. For a
            detailed analysis specific to your address, contact your local Davey
            dealer.
          </li>
          <li>
            Therefore, any under or over sizing of the heater for your pool
            heating requirements is not the responsibility of Davey Water
            Products.
          </li>
          <li>
            Davey Water Products will not be held responsible for installation
            by your installer or running cost of your heater as a result of
            selecting the recommended model.
          </li>
          <li>
            The pool heat pump sizing calculation is based on a maximum set
            temperature. At initial cold water start up the heat pump may need
            to run for a longer period per day to reach the set temperature.
          </li>
          <li>
            This calculator is optimised for day time heat pump operation at 26C
            ambient air temperature.
          </li>
          <li>
            Operation in low ambient temperatures, windy locations and pool
            water features will require additional heating capacity which may
            require a larger size pool heat pump.
          </li>
          <li>
            Sizing a pool heat pump in cooler locations requiring winter season
            heating should be achieved at a maximum of 8 hours daytime
            operation.
          </li>
          <li>
            When pool cover is used, this calculation assumes the use of a pool
            cover while heating the pool in order to meet expectations when
            maintaining temperature, reaching initial heat up time and
            calculating estimated cost of usage.
          </li>
          <li>Average Costs are indicative only.</li>
          <li>Dollar values have been rounded to the nearest dollar.</li>
          <li>
            Volume calculation is adjusted based on pool material (Slope side
            for Fibre glass and Liner material, Straight side for concrete
            material).
          </li>
          <li>
            This calculator does not applicable for infinity pool. Please
            contact Davey Support team for further enquiries.
          </li>
        </ul>
      </Typography>
    </Box>
  );
};
